import React from 'react';
import { useNavigate } from 'react-router-dom';

export const AuthError: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center p-8 max-w-md">
        <div className="rounded-full bg-red-100 p-3 w-16 h-16 flex items-center justify-center mx-auto">
          <svg className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h2 className="mt-4 text-2xl font-bold text-foreground">Authentication Failed</h2>
        <p className="mt-2 text-muted-foreground">
          Sorry, we couldn't complete the authentication process. Please try again.
        </p>
        <button 
          className="mt-6 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          onClick={() => navigate('/oauth')}
        >
          Return to Login
        </button>
      </div>
    </div>
  );
};

export default AuthError;